<template>
  <annotatable-rich-text
    v-if="showAnnotatableRichText"
    v-bind="attrs"
    :can-annotate="props.canAnnotate"
    :can-assess="props.canAssess"
    :allow-ask-salis="props.allowAskSalis"
    @rich-text-ready="handleReady"
  />
  <rich-text v-else v-bind="attrs" @ready="handleReady" />
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";
import RichText from "@plugins/richtext/components/RichText.vue";
import AnnotatableRichText from "@modules/annotation/components/AnnotatableRichText.vue";

// Props
interface Props {
  // Retained for the attempt side: it passes allowAnnotate=true so existing annotations stay
  // visible even when the user's canAnnotate/canAssess permissions are false.
  allowAnnotate?: boolean;
  canAnnotate?: boolean;
  canAssess?: boolean;
  allowAskSalis?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  richTextReady: [];
}>();

// Composables
const attrs = useAttrs();

// Computed
const showAnnotatableRichText = computed(() => {
  return props.allowAnnotate || props.canAnnotate || props.canAssess || props.allowAskSalis;
});

const handleReady = (): void => {
  emit("richTextReady");
};
</script>
